import React, { useState, useEffect } from 'react'
import { Modal } from 'antd'
import { notificationToast } from 'components'
import styled from '@emotion/styled'
import { getAuthHeader, setUser } from 'utils/auth'
import ChargeStep from 'views/Payment/ChargeStep'
import { useAuth } from 'context/auth-context'
import { useUser } from 'context/user-context'
import useAxios from 'axios-hooks'
import TransactionsListTop from 'views/UserManagement/Transactions/Components/TransactionsListTop'
import TransactionsList from 'views/UserManagement/Transactions/Components/TransactionsList'
import TransactionsDetailModal from 'views/UserManagement/Transactions/Components/TransactionsDetailModal'
import EditCardModal from 'views/Payment/EditCardModal'
import { useAccount } from 'context/account-context'

const StyledModal = styled(Modal)`
  .ant-modal-footer {
    border-top: none !important;
  }
`

function SubscriptionTransactions() {
  const { reloadUserInfo } = useAuth()
  const user = useUser()
  const accounts = useAccount()
  const [detailsModalVisible, setDetailsModalVisible] = useState(false)
  const [editModalVisible, setEditModalVisible] = useState(false)
  const [renewModalVisible, setRenewModalVisible] = useState(false)
  const [detailsDate, setDetailsDate] = useState('')

  // GET transactions list
  const [
    { data: transactionsData, loading: transactionsLoading, error: transactionsError },
    getTransactions
  ] = useAxios({
    url: '/payment/transactions',
    method: 'GET',
    headers: getAuthHeader()
  })

  // POST transactions details
  const [
    { data: transactionsDetailsData, loading: transactionsDetailsLoading, error: transactionsDetailsError },
    getTransactionsDetails
  ] = useAxios(
    {
      url: '/payment/transactions-detail',
      method: 'POST',
      headers: getAuthHeader()
    },
    { manual: true }
  )

  // POST cancel the subscrption
  const [
    { data: cancelSubscriptionData, loading: cancelSubscriptionLoading, error: cancelSubscriptionError },
    cancelSubscription
  ] = useAxios(
    {
      url: '/payment/cancel',
      method: 'POST',
      headers: getAuthHeader()
    },
    { manual: true }
  )

  // POST refresh subscription status for account
  const [
    { data: changeAccountData, loading: changeAccountLoading, error: changeAccountError },
    changeAccountApi
  ] = useAxios(
    {
      method: 'POST',
      url: `/account/change-account`,
      headers: getAuthHeader()
    },
    { manual: true }
  )

  const [{ data: tiersData, loading: tiersLoading, error: tiersError }, getTiers] = useAxios({
    method: 'GET',
    url: `/payment/tiers`,
    headers: getAuthHeader()
  })

  const [{ data: configData, loading: configLoading, error: condifgError }] = useAxios({
    url: '/payment/configuration',
    method: 'GET',
    headers: getAuthHeader()
  })

  const fetchTransactionDetails = (date) => {
    getTransactionsDetails({ data: { date } })
    setDetailsDate(date)
    setDetailsModalVisible(true)
  }

  useEffect(() => {
    if (cancelSubscriptionData) {
      let currentAccount = accounts.filter((account) => account.current)[0]
      changeAccountApi({ data: { account_id: currentAccount.id } })
    }
  }, [cancelSubscriptionData])

  useEffect(() => {
    if (cancelSubscriptionError) {
      //error inside cancelmodal...
    }
  }, [cancelSubscriptionError])

  useEffect(() => {
    if (changeAccountData) {
      notificationToast({
        message: 'Success',
        description: 'Subscription has been cancelled.',
        icontype: 'check'
      })
      setUser({ data: changeAccountData })
      reloadUserInfo()
    }
  }, [changeAccountData])

  return (
    <>
      <TransactionsListTop
        subscriptionIsActive={user.payg_subscription_status == 'active'}
        cancelFee={transactionsData && transactionsData.filter((t) => t.invoiceId == null)[0]?.amount}
        setEditModalVisible={setEditModalVisible}
        cancelSubscription={cancelSubscription}
        setRenewModalVisible={setRenewModalVisible}
      />
      <TransactionsList
        data={transactionsData}
        loading={transactionsLoading}
        setDetailsModalVisible={setDetailsModalVisible}
        fetchTransactionDetails={fetchTransactionDetails}
      />

      <TransactionsDetailModal
        data={transactionsDetailsData}
        loading={transactionsDetailsLoading}
        detailsDate={detailsDate}
        transactions={transactionsData}
        fetchTransactionDetailsMonth={fetchTransactionDetails}
        setDetailsModalVisible={setDetailsModalVisible}
        modalVisible={detailsModalVisible}
      />

      {configData && <EditCardModal editModalVisible={editModalVisible} setEditModalVisible={setEditModalVisible} stripePK={configData} />}
      {configData && <StyledModal
        centered
        width="40%"
        title={'Renew Subscription'}
        visible={renewModalVisible}
        onCancel={() => setRenewModalVisible(false)}
        footer={[]}
      >
       <ChargeStep tiersData={tiersData} setPaymentModalOpen={setRenewModalVisible} stripePK={configData}/>
      </StyledModal>}
    </>
  )
}

export default SubscriptionTransactions
